import { useTranslation } from 'react-i18next'

import { LLMReasoningBadgeProps } from './LLMReasoningBadge.types'
import { Badge } from '@percent/lemonade'
import { MatchStatus, RoleValidity } from '@percent/admin-dashboard/api/types'

export function LLMReasoningBadge({ status }: LLMReasoningBadgeProps) {
  const { t } = useTranslation()

  if (Object.values(MatchStatus).includes(status as MatchStatus)) {
    switch (status as MatchStatus) {
      case MatchStatus.EXACT_MATCH:
        return (
          <Badge variant="positive" icon="check-badge">
            {t('typography.exactMatch')}
          </Badge>
        )
      case MatchStatus.PARTIAL_MATCH:
        return (
          <Badge variant="warning" icon="warning">
            {t('typography.partialMatch')}
          </Badge>
        )
      case MatchStatus.ALLOWED_ORGANIZATION:
        return (
          <Badge variant="informative" icon="check-badge">
            {t('typography.allowedOrganization')}
          </Badge>
        )
      case MatchStatus.NO_MATCH:
        return (
          <Badge variant="critical" icon="warning">
            {t('typography.noMatch')}
          </Badge>
        )
    }
  }

  if (Object.values(RoleValidity).includes(status as RoleValidity)) {
    switch (status as RoleValidity) {
      case RoleValidity.ACCEPTABLE:
        return (
          <Badge variant="positive" icon="check-badge">
            {t('typography.roleAcceptable')}
          </Badge>
        )
      case RoleValidity.NOT_ACCEPTABLE:
        return (
          <Badge variant="critical" icon="warning">
            {t('typography.roleNotAcceptable')}
          </Badge>
        )
      case RoleValidity.UNCLEAR:
        return (
          <Badge variant="informative" icon="check-badge">
            {t('typography.roleUnclear')}
          </Badge>
        )
    }
  }

  return null
}
